var render = function render(){var _vm=this,_c=_vm._self._c;return _c('imports-select-submissions-table',{attrs:{"value":_vm.selectedIds,"submissions":_vm.submissions,"assignment-link":_vm.assignmentLink,"show-open-in-lms":_vm.showOpenInLms,"loading":_vm.loading},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }